import React, { useState, useEffect }  from 'react'
import { Table,  Space } from 'antd'
import Main from '../../../cpn/Main';
import IncomeNodeDel from './IncomeNodeDel';
import IncomeNodeAdd from './IncomeNodeAdd';
import IncomeNodeCheck from './IncomeNodeCheck';
import IncomeNodeCopyAdd from './IncomeNodeCopyAdd';
import { useSKspjdListQuery } from '../../../store/DianShangYeWuApi';
function IncomeNodeList() {
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useSKspjdListQuery({ddsr_spjd_qy_id:qy_id});
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){            
            // 找出所有不同的ddsr_spjd_user_id并合并
            const mergedArr = [];
            const userMap = {};
            data.Result.forEach(item => {
                // 用ddsr_spjd_user_id去合并
                if (item.ddsr_spjd_user_id && !userMap[item.ddsr_spjd_user_id]) {
                    userMap[item.ddsr_spjd_user_id] = {
                        key: item.ddsr_spjd_user_id,
                        ddsr_spjd_user_id: item.ddsr_spjd_user_id,
                        ddsr_spjd_user_name: item.ddsr_spjd_user_name,
                        ddsr_spjd_name: item.ddsr_spjd_name,
                        ddsr_spjd_yh_id: item.ddsr_spjd_yh_id,
                        ddsr_spjd_yh_name: item.ddsr_spjd_yh_name,
                        yh_id: item.ddsr_spjd_yh_id,
                        yh_name: item.ddsr_spjd_yh_name,
                    }
                    mergedArr.push(userMap[item.ddsr_spjd_user_id])
                }
            })
            setList(mergedArr);
        }else{
            setList([]);
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '收款单操作员',
            dataIndex: 'ddsr_spjd_user_name',
            key: 'ddsr_spjd_user_name',
            width: 300, 
            render: (text, record) => <Space>
                <IncomeNodeCheck
                    user_id={record.ddsr_spjd_user_id}
                    user_name={record.ddsr_spjd_user_name}
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                    ddsr_spjd_user_id={record.ddsr_spjd_user_id}
                    ddsr_spjd_user_name={record.ddsr_spjd_user_name}
                />
            </Space>
        },
        {
            title: '操作',
            key: 'action',
            render: (text, record) => <Space size={20}>
                <IncomeNodeDel
                    ddsr_spjd_user_id={record.ddsr_spjd_user_id}                    
                />
                <IncomeNodeCopyAdd
                    ddsr_spjd_user_id={record.ddsr_spjd_user_id}  
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Space>
        },
    ]
    return (
        <Main selectedKeys={['/IncomeNodeList']}>
            <IncomeNodeAdd  
                qy_id={qy_id}
                qy_name={qy_name}
                yh_id={yh_id}
                yh_name={yh_name}
            />
            <Table
                columns={columns}
                dataSource={list}
                style={{marginTop:'10px',width:'500px'}}
                className="custom-table"
                size='small'
                bordered
                rowKey="key"
            />
        </Main>
    )
}

export default IncomeNodeList